import { makeStyles } from "tss-react/mui";
import { Box, Modal } from "@mui/material";

export const MiVideoViewer = ({ videoUrl, modalOpen, setModalOpen }) => {
  const { classes } = useStyles();
  return (
    <Modal open={modalOpen} onClose={() => setModalOpen(false)}>
      <Box className={classes.modalContainer}>
        <video controls width="100%" height="100%" src={videoUrl}>
          <track kind="captions" default />
        </video>
      </Box>
    </Modal>
  );
};

const useStyles = makeStyles()(() => ({
  modalContainer: {
    position: "absolute",
    top: "50%",
    left: "50%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    transform: "translate(-50%, -50%)",
    width: "50%",
    height: "50%",
    borderRadius: 16,
    boxShadow: 24,
  },
}));
